<template>
  <div v-loading.fullscreen.lock="fullscreenLoading">
    <el-form class="toolbar" :inline="true" size="mini">
      <el-form-item label="关键字">
        <el-input v-model="params.keyword" placeholder="请输入关键字" clearable></el-input>
      </el-form-item>
      <el-form-item label="开始时间">
        <el-date-picker
          v-model="params.d1"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择开始时间">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="结束时间">
        <el-date-picker
          v-model="params.d2"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择结束时间">
        </el-date-picker>
      </el-form-item>

      <el-button type="primary" @click="listSearch" size="mini">查询</el-button>
      <el-button type="success" @click="addCompany" size="mini">新增</el-button>
    </el-form>
    <paging :url="url.list" :params="params" ref="paging" style="width: 990px;">
      <el-table border slot-scope="grid" :data="grid.data" style="width: 100%;" height="500px" v-loading="grid.loading || loading">
        <el-table-column align="center" prop="F_Name" label="公司名称" width="140">
          <template slot-scope="scope">
            <el-button @click="onEdit(scope.row,false)" type="text" size="small">{{scope.row.F_Name}}</el-button>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="F_RoadLicenseNo" label="道路运输经营许可证号" width="180"></el-table-column>
        <el-table-column align="center" prop="F_RoadLicenseDate" label="道路运输经营许可证号有效期" width="180"></el-table-column>
        <el-table-column align="center" prop="F_SafetyLicenseNo" label="安全生产许可证号" width="180"></el-table-column>
        <el-table-column align="center" prop="F_SafetyLicenseDate" label="安全生产许可证有效期" width="180"></el-table-column>
        <el-table-column align="center" prop="F_BusinessLicenseNo" label="经营许可证号" width="150"></el-table-column>
        <el-table-column align="center" prop="F_BusinessLicenseDate" label="经营许可证有效期" width="160"></el-table-column>
        <el-table-column align="center" prop="F_PermitLicenseNo" label="剧毒购买凭证或准购许可证" width="140"></el-table-column>
        <el-table-column align="center" prop="F_PermitLicenseDate" label="剧毒购买凭证或准购许可证有效期" width="160"></el-table-column>
        <!--<el-table-column align="center" prop="F_TelNo" label="剧毒购买凭证或准购许可证有效期" width="160"></el-table-column>-->

        <!--<el-table-column align="center" prop="Status" label="状态" width="120">-->
          <!--<template slot-scope="scope">-->
            <!--<el-tag type="default" v-if="scope.row.Status == 1" size="medium">待提货</el-tag>-->
            <!--<el-tag type="success" v-else-if="scope.row.Status == 16" size="medium">已支付</el-tag>-->
            <!--<el-tag type="default" v-else-if="scope.row.Status == 2" size="medium">已制卡</el-tag>-->
            <!--<el-tag type="default" v-else-if="scope.row.Status == 3" size="medium">已叫号</el-tag>-->
            <!--<el-tag type="default" v-else-if="scope.row.Status == 4" size="medium">已进场</el-tag>-->
            <!--<el-tag type="default" v-else-if="scope.row.Status == 5" size="medium">叫号超时</el-tag>-->
            <!--<el-tag type="default" v-else-if="scope.row.Status == 6" size="medium">过皮重</el-tag>-->
            <!--<el-tag type="default" v-else-if="scope.row.Status == 7" size="medium">正在装车</el-tag>-->
            <!--<el-tag type="default" v-else-if="scope.row.Status == 8" size="medium">装车结束</el-tag>-->
            <!--<el-tag type="default" v-else-if="scope.row.Status == 9" size="medium">过毛重</el-tag>-->
            <!--<el-tag type="success" v-else-if="scope.row.Status == 10" size="medium">已结算</el-tag>-->
            <!--<el-tag type="success" v-else-if="scope.row.Status == 11" size="medium">已出场</el-tag>-->
            <!--<el-tag type="info" v-else-if="scope.row.Status == 12" size="medium">已作废</el-tag>-->
            <!--<el-tag type="default" v-else-if="scope.row.Status == 13" size="medium">正在计算含水</el-tag>-->
            <!--<el-tag type="info" v-else-if="scope.row.Status == 14" size="medium">请求制卡</el-tag>-->
            <!--<el-tag type="default" v-else-if="scope.row.Status == 15" size="medium">制卡失败</el-tag>-->
            <!--<el-tag type="info" v-else-if="scope.row.Status == -2" size="medium">超时</el-tag>-->
            <!--<el-tag type="info" v-else-if="scope.row.Status == -12" size="medium">作废中</el-tag>-->
            <!--&lt;!&ndash;<el-tag type="info" v-else-if="scope.row.Status == 0 && orderStatus== 0" size="medium">待支付</el-tag>&ndash;&gt;-->
            <!--<el-tag type="info" v-else-if="scope.row.Status == 0" size="medium">待生效</el-tag>-->
            <!--<el-tag type="info" v-else-if="scope.row.Status == -1" size="medium">上传中</el-tag>-->
          <!--</template>-->
        <!--</el-table-column>-->
        <el-table-column fixed="right" label="操作" width="220" header-align="center" align="center">
          <template slot-scope="scope">
            <el-button @click="onEdit(scope.row,true)" type="text" size="small">编辑</el-button>
            <el-button @click="onDelete(scope.row)" type="text" size="small">删除</el-button>
            <el-button @click="onPhone(scope.row)" type="text" size="small">关联手机号</el-button>
          </template>
        </el-table-column>
      </el-table>
    </paging>

    <!--修改弹框-->
    <dialog-form title="运输单位"
                 :formTemplate="formTemplate"
                 :visible.sync="visible"
                 :form="form" :rules="rules"
                 :url="url.save"
                 :isEdit="isEdit"
                 :canEdit="canEdit"
                 :labelPosition="labelPosition"
                 :labelWidth="labelWidth"
                 @beforeSave="beforeSave"
                 @saved="editSave()">
    </dialog-form>

    <el-dialog :close-on-click-modal="false" center title="关联手机号" :visible.sync="dialogTablePhone">
      <el-button @click="" type="text" size="small"></el-button>
      <el-table :data="Phones" border>
        <el-table-column header-align="center" align="center" property="F_TelNo" label="手机号"></el-table-column>
        <el-table-column header-align="center" align="center" property="F_CreateTime" label="创建时间"></el-table-column>
        <el-table-column header-align="center" align="center" property="F_Creator" label="操作人"></el-table-column>
        <el-table-column fixed="right" label="操作" width="100" header-align="center" align="center">
          <template slot-scope="scope">
            <el-button @click="onDeletePhone(scope.row)" type="text" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="success" @click="addPhone">新增关联手机号</el-button>
        <el-button type="primary" @click="dialogTablePhone = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/javascript">
  import Paging from '@/components/Table/Paging'
  import DialogForm from '@/components/Dialogs/DialogForm';

  export default {
    components: {
      Paging, DialogForm
    },
    props: {
      screen: {
        type: Object,
        default: () => {
        }
      },
    },
    data() {
      let validateCarNo = (rule, value, callback) => {
        let regex = /(^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领台A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1}$)/;
        if (value != null && !regex.test(value)) {
          callback(new Error('请输入正确的车牌号'));
        } else {
          callback();
        }
      }
      return {
        labelWidth:'250px',
        labelPosition:'right',
        url: {
          list: SZH.assets.api + '/WHPTransCompany/GetGridJson',
          save: SZH.assets.api + '/WHPTransCompany/SumbitForm',
          delete: SZH.assets.api + '/WHPTransCompany/DeleteForm',
          get: SZH.assets.api + '/WHPTransCompany/GetFormJson',
          GetGridJsonLinkUser: SZH.assets.api + '/WHPDriver/GetGridJsonLinkUser',
          InsertLinkTelUser: SZH.assets.api + '/WHPDriver/InsertLinkTelUser',
          DeleteLinkTelUser: SZH.assets.api + '/WHPDriver/DeleteLinkTelUser',
        },
        loading: false,
        fullscreenLoading: false,
        params: {
          keyword:'',
          d1:'',
          d2:''
        },
        visible: false,
        form: {
          F_Id: '',
          F_Name: '',
          F_RoadLicenseNo: '',
          F_RoadLicenseDate: '',
          F_SafetyLicenseNo: '',
          F_SafetyLicenseDate: '',
          F_BusinessLicenseNo: '',
          F_BusinessLicenseDate: '',
          F_PermitLicenseNo: '',
          F_PermitLicenseDate: '',
          F_ImgUrlBefore: [],
          F_ImgUrl:'',
          F_ImgBase64:''

        },
        isEdit:false,
        formTemplate: [
          {col: 24, label: '公司名称', prop: 'F_Name'},
          {col: 24, label: '道路运输经营许可证号', prop: 'F_RoadLicenseNo'},
          {col: 24, label: '道路运输经营许可证号有效期', prop: 'F_RoadLicenseDate',type: "date"},
          {col: 24, label: '安全生产许可证号', prop: 'F_SafetyLicenseNo'},
          {col: 24, label: '安全生产许可证有效期', prop: 'F_SafetyLicenseDate',type: "date"},
          {col: 24, label: '经营许可证号', prop: 'F_BusinessLicenseNo'},
          {col: 24, label: '经营许可证有效期', prop: 'F_BusinessLicenseDate',type: "date"},
          {col: 24, label: '剧毒购买凭证或准购许可证', prop: 'F_PermitLicenseNo'},
          {col: 24, label: '剧毒购买凭证或准购许可证有效期', prop: 'F_PermitLicenseDate',type: "date"},
          {col: 24, label: '道路运输经营许可证照片', prop: 'F_ImgUrlBefore',type: "pictureBase",default: [],formIdProp: "Id",pictureType: "WHPimg",limit: 1,},
        ],
        rules: {
          F_Name: [
            {required: true, message: '请输入公司名称', trigger: 'blur'},
          ],
          F_RoadLicenseNo: [
            {required: true, message: '请输入道路运输经营许可证号', trigger: 'blur'},
          ],
          F_RoadLicenseDate: [
            {required: true, message: '请选择道路运输经营许可证号有效期', trigger: 'change'},
          ],
          F_SafetyLicenseNo: [
            {required: true, message: '请输入安全生产许可证号', trigger: 'blur'},
          ],
          F_SafetyLicenseDate: [
            {required: true, message: '请选择安全生产许可证有效期', trigger: 'change'},
          ],
          F_BusinessLicenseNo: [
            {required: true, message: '请输入经营许可证号', trigger: 'blur'},
          ],
          F_BusinessLicenseDate: [
            {required: true, message: '请选择经营许可证有效期', trigger: 'change'},
          ],
          F_PermitLicenseNo: [
            {required: true, message: '请输入剧毒购买凭证或准购许可证', trigger: 'blur'},
          ],
          F_PermitLicenseDate: [
            {required: true, message: '请选择剧毒购买凭证或准购许可证有效期', trigger: 'change'},
          ],
          F_ImgUrlBefore: [
            {required: true, message: '请选择道路运输经营许可证照片', trigger: 'change'},
          ],
        },
        canEdit:false,
        dialogTablePhone:false,
        Phones:[],
        row:''
      }
    },
    methods: {
      onPhone(row){
        let self = this;
        self.dialogTablePhone = true;
        self.getPhones(row);
      },
      getPhones(row){
        let self = this;
        self.row = row;
        self.fullscreenLoading = true;
        self.$http.post(self.url.GetGridJsonLinkUser, {
          Data:{
            keyValue: row.F_Id
          },
          PageIndex:1,
          PageSize:200
        }).then(result => {
          if (result.state == true) {
            self.Phones = result.data.Data
          } else {
            self.Phones = [];
            self.$message.error(result.message);
          }
          self.fullscreenLoading = false;
        }, () => {
          self.fullscreenLoading = false;
          self.$message.error('数据作废失败，请检查您的网络是否可用。');
        });
      },
      addPhone(){
        let self = this;
        self.$prompt('请输入手机号', '新增手机号', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /^((13|14|15|17|18|19|16|11|12)[0-9]{9})?$/,
          inputErrorMessage: '手机号格式不正确',
          closeOnClickModal:false,
          center: true
        }).then(({ value }) => {
          self.fullscreenLoading = true;
          self.$http.post(self.url.InsertLinkTelUser, {
            F_TelNo:value,
            F_Type:0,
            F_ObjectId:self.row.F_Id
          }).then(result => {
            if (result.state == true) {
              self.$message.success('操作成功');
              self.getPhones(self.row);
            } else {
              self.$message.error(result.message);
            }
            self.fullscreenLoading = false;
          }, () => {
            self.fullscreenLoading = false;
            self.$message.error('数据作废失败，请检查您的网络是否可用。');
          });
        }).catch(() => {

        });
      },
      onDeletePhone(row){
        var self = this;
        self.$confirm(`将手机号${row.F_TelNo}删除, 是否继续?`, '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          self.fullscreenLoading = true;
          self.$http.post(self.url.DeleteLinkTelUser, {
            keyValue: row.F_Id
          }).then(result => {
            if (result.state == true) {
              self.$message.success('删除成功!');
              self.getPhones(self.row);
            } else {
              self.$message.error(result.message);
            }
            self.fullscreenLoading = false;
          }, () => {
            self.fullscreenLoading = false;
            self.$message.error('数据作废失败，请检查您的网络是否可用。');
          });
        }).catch(() => {
          self.$message({
            type: 'info',
            message: '已取消操作'
          });
        });
      },
      addCompany(){
        let self = this;
        self.visible = true;
        self.canEdit = true;
        self.form.F_ImgUrlBefore = [];
      },
      listSearch() {
        this.$refs['paging'].reload();
      },
      beforeSave(){
        let self = this;
        self.form.F_ImgUrl = self.form.F_ImgUrlBefore[0].path;
      },
      // 保存
      editSave() {
        this.$message.success('保存成功');
        this.$refs['paging'].reload();
      },
      onEdit(row,flag){
        let self = this;
        const loading = self.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        self.visible = true;
        self.form.F_ImgUrlBefore = [];
        self.canEdit = flag;
        self.$http.post(self.url.get, {
          keyValue: row.F_Id
        }).then(result => {
          if (result.state == true) {

            self.$nextTick(()=>{
              for(let i in self.form){
                for(let k in result.data){
                  if(i == k){
                    self.form[i] = result.data[k];
                  }
                }
                if(i == 'F_ImgBase64'){
                  let obj = {
                    path:result.data.F_ImgUrl,
                    Url:result.data.F_ImgBase64
                  };
                  self.form.F_ImgUrlBefore.push(obj);
                }
              }
            });
          } else {

          }
          loading.close();
        }, () => {
          loading.close();
          self.$message.error('数据作废失败，请检查您的网络是否可用。');
        });
      },
      onDelete(row) {
        var self = this;
        self.$confirm(`将${row.F_Name}删除, 是否继续?`, '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          self.fullscreenLoading = true;
          self.$http.post(self.url.delete, {
            keyValue: row.F_Id
          }).then(result => {
            if (result.state == true) {
              self.$refs['paging'].loadData();
            } else {
              self.$message.error(result.message);
            }
            self.fullscreenLoading = false;
          }, () => {
            self.fullscreenLoading = false;
            self.$message.error('数据作废失败，请检查您的网络是否可用。');
          });
        }).catch(() => {
          self.$message({
            type: 'info',
            message: '已取消操作'
          });
        });
      },
    },
    computed: {},
    created() {
    },
    mounted() {

    },
    watch: {}

  }
</script>

<style type="text/css" scoped>

</style>



// WEBPACK FOOTER //
// src/views/Me/HazardousChemicalsEntry/TransportationCompany/TransportationCompany.vue